import { useSplitTests } from '@api/lendingAPI/lapiHooks';

import { ConfirmDrawdownPlaceholder } from './ConfirmDrawdownPlaceholder';
import ConfirmFundingView from '../ConfirmFundingView/ConfirmFundingView';

const SPLIT_TEST_NAME = 'new_customer_drawdown_confirmation_q4_2026';

export const ConfirmDrawdownGate = () => {
    const isNewDrawdownPage = useSplitTests(SPLIT_TEST_NAME);

    return isNewDrawdownPage ? (
        <ConfirmDrawdownPlaceholder />
    ) : (
        <ConfirmFundingView />
    );
};
